import apiClient from "./client";

export async function landing({ request }) {
  const response = await apiClient.post("/api/landing", { request });
  return response.data;
}

export async function getUserRequest({ id }) {
  const response = await apiClient.post("/api/get_user_request", { id });
  return response.data;
}

export async function buildReport({ userRequest, user_request, persona, plan }) {
  const response = await apiClient.post("/api/build_report", {
    user_request: user_request || userRequest,
    persona,
    simple_plan: plan || undefined,
  });
  return response.data;
}

export async function buildReportAsync({ userRequest, user_request, persona }) {
  const response = await apiClient.post("/api/build_report_async", {
    user_request: user_request || userRequest,
    persona,
  });
  return response.data;
}

export async function buildPlanAsync({ userRequest, user_request, persona }) {
  const response = await apiClient.post("/api/build_plan_async", {
    user_request: user_request || userRequest,
    persona,
  });
  return response.data;
}

export async function buildReportOnlyAsync({ user_request, sectioned_plan, persona }) {
  const response = await apiClient.post("/api/build_report_only_async", {
    user_request: user_request,
    sectioned_plan: sectioned_plan,
    persona,
  });
  return response.data;
}

export async function getTask({ task_id }) {
  const response = await apiClient.post("/api/get_task", {
    task_id: task_id,
  });
  return response.data;
}

export async function getTaskResult({ task_id }) {
  const response = await apiClient.post("/api/get_task_result", {
    task_id: task_id,
  });
  return response.data;
}

export async function getAboutMe() {
  const response = await apiClient.post("/api/about/me", {});
  return response.data;
}

export async function getSlide({ input }) {
  const response = await apiClient.post("/api/get_slide", { input });
  return response.data;
}

export async function getPresentation({ presentation_id }) {
  const response = await apiClient.post("/api/get_presentation", { presentation_id });
  return response.data;
}

export async function setPresentation({ presentation_id, slides }) {
  const response = await apiClient.post("/api/set_presentation", { presentation_id, slides });
  return response.data;
}
